import React from 'react';
import Layout from '../components/layout';
import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';
import MeetBimboLayout from '../components/MeetBimboLayout';

const meetBimbo = (props) => {
  return (
    <Layout>
      <PageHeader
        fontSize={14}
        background={'#00C5F6'}
        color={'white'}
        height={5}
        headercenter={'MEET BIMBO'}
        subheader={'Lorem ipsum dolor sit amet, nostrud exercitation ullamco.'}
      />

      <MeetBimboLayout />

      <Footer />
    </Layout>
  );
};

export default meetBimbo;
